import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class BeneficialOwnerCitizenship {
}
export class BeneficialOwnerResourceV2 extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.beneficialOwnerId = "";
        this.isActualBeneficialOwner = false;
        this.citizenships = [];
    }
    pk() {
        return this.beneficialOwnerId;
    }
    static listUrl(allParams = {}) {
        const { customerId, applicationId, customerRole } = allParams;
        if (customerRole !== undefined) {
            return `${this.urlRoot}/${applicationId}/${customerRole}`;
        }
        if (customerId !== undefined) {
            return `${this.urlRoot}/${customerId}`;
        }
        throw new Error("BeneficialOwnerResourceV2 requires customerId");
    }
}
BeneficialOwnerResourceV2.urlRoot = apiResourceUrl("beneficial-owner-v2/");
BeneficialOwnerResourceV2.urlTemplates = [
    `${BeneficialOwnerResourceV2.urlRoot}/{applicationId}`
];
export class BeneficialOwnerVerificationResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId ?? "";
    }
}
BeneficialOwnerVerificationResource.urlRoot = apiResourceUrl("beneficial-owner-v2/verification");
BeneficialOwnerVerificationResource.urlTemplates = [
    `${BeneficialOwnerVerificationResource.urlRoot}/{customerId}`
];
//# sourceMappingURL=BeneficialOwnerResourceV2.js.map